<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Campaign</h3>

    <label>Campaign url params prefix</label>
    <input v-model="resource.campaign_prefix" type="text" />
    <span v-if="errors.campaign_prefix" class="alert -inline -danger">
      {{ [...errors.campaign_prefix].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["campaign_prefix"]
    };
  }
};
</script>
